import { http } from "@/config/httpCommon"

export default {
    state: {
        container: [],
        designs: []
    },
    mutations: {
        set (state, [variable, value]) {
            state[variable] = value
        },
        add (state, payload) {
            state.container.push(payload);
        },
        ADD_FILE(state, payload){
            let index = state.container.findIndex(cont => cont.id == payload.container_id);
            let file_index = state.container[index].files.findIndex(file=>file.id==payload.id);
           if(file_index < 0){
                state.container[index].files.push(payload);
            }else{
                state.container[index].files[file_index] = payload;
            }
        },
        ADD_CONTAINER(state, payload){
            state.container.push(payload)
        }
    },
    getters:{
        getContainer(state){
            return state.container;
        },
    },
    actions: {
        async getContainer({commit},payload=''){
            let res = await http.get(`container`+payload);
            commit('set', ['container', res.data.data]);
            return res;
        },
        async getAllContainer({commit}, params){
            let res = await http.get(`containers-list`+params);
            commit('set', ['container', res.data.data]);
            return res;
        },
        async addContainer({commit}, payload){
            let res = await http.post(`container`, payload);
            commit('ADD_CONTAINER', res.data.data);
            return res;
        },
        async addContainerFile({commit}, payload){
            let res = await http.post(`containerfile`, payload);
           // console.log('file added in container', res.data);
            commit('ADD_FILE', res.data);
            return res;
        },
        async updateContainerFile({commit}, payload){
            let res = await http.post(`update-containerfile`, payload);
           // console.log('file added in container', res.data);
            commit('ADD_FILE', res.data);
            return res;
        },
        async uploadContainerZipFile({commit}, formData){
            let res = await http.post(`containerzipfile`, formData , {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            console.log(commit);
           // console.log('file added in container', res.data);
           // commit('ADD_FILE', res.data);
            return res;
        },
        async getContainerDesigns({commit}, payload){
            let res = await http.get(`container/designs/${payload}`);
            commit('set', ['designs', res.data]);
            return res;
        },
        async getFileDesigns(_, payload){
            let res = await http.get(`container/file-designs/${payload}`);
            return res;
        },
        async deleteFileDesigns(_, payload){
            let res = await http.post(`container/delete-file-designs`,payload);
            return res;
        }
    }
}